export const LIGHT_COLOR_LUMINANCE_THRESHOLD = 0.6;

export const HEX_COLOR_REGEX = /^#?(?:[a-fA-F\d]{3}){1,2}$/;

export const RGB_COLOR_REGEX = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/;

export const RED_LUMINANCE_WEIGHT = 0.299;
export const GREEN_LUMINANCE_WEIGHT = 0.587;
export const BLUE_LUMINANCE_WEIGHT = 0.114;
